import React from "react";
import "./App.scss";
import AppHeader from "../../common/components/AppHeader/AppHeader";

function App() {
  return (
    <div className="App">
      <AppHeader />
    </div>
  );
}

export default App;
